import GroupWithUsers from "./entities/GroupWithUsers"
import UserInGroup from "./entities/UserInGroup"
import AddGroupController from "./add_group_controller"
import {atUserGroupManagementActionsProvider} from "./actionsProviders";
import {GroupExistsError} from "./errors";

export default class ATAddUserGroupController extends AddGroupController {
    createUserGroupRpc(controller) {
        atUserGroupManagementActionsProvider.createUserGroup(this.getNewGroupData())
                .then(data => {
                    const groupWithUsersData = data["groupWithUsers"];
                    const group = new GroupWithUsers(
                            groupWithUsersData["group"]["id"],
                            groupWithUsersData["group"]["name"],
                            controller.validatorGroupStrategy,
                            groupWithUsersData["users"]["list"].map(u => new UserInGroup(u["id"], u["name"], u["active"])),
                    )
                    controller.rebuildViewAfterGroupCreation(group)
                })
                .catch(e => {
                    console.error(e);
                    if (e instanceof GroupExistsError) {
                        controller.getAddGroupController().resetRowIntoDefaultState();
                        controller.showDuplicateUserGroupMessage();
                    }
                });

        this.spinnerController.spin(this.waitingAnimationCellId);
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/ATAddUserGroupController.js